export default "__VITE_ASSET__CijDovxT__"